import type { UserSummary } from '@models/api';
import { isRecord } from '../collections';

// Re-exported from `../collections` (shared with `events/helpers.ts`) so both cache domains --
// and `../collections`'s own `patchDetailData` -- use one implementation (#953 review).
export { isRecord } from '../collections';

export const asArray = <T>(value: unknown, predicate: (entry: unknown) => entry is T): T[] => {
  if (!Array.isArray(value)) return [];
  return (value as unknown[]).filter(predicate);
};

export const isUserSummary = (value: unknown): value is UserSummary => {
  if (!isRecord(value)) return false;
  return typeof value.id === 'string';
};
